import React from 'react'
import { IAttachmentDTO, selectAllAttachments } from '@user/store/attachments'
import { permissionDenied } from '@user/store/authorization/permissions'
import { useSelector } from 'react-redux'
import { fileMimeTypes } from '../typings'

import { FileSelect } from '../../FileSelect/FileSelect'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { SaleCenterAttachmentsList } from './SaleCenterAttachmentsList'
import { ButtonWithTooltip } from '@sales-center/components'
import { useSelectedAttachmentStore } from '../selectedAttachmentStore'

type Props = {
  canUpdate: boolean
  attachments: IAttachmentDTO[]
  openFileSelect: () => void
  handleFilesAdded: (files: FileList) => void
}

export function SaleCenterAttachments(props: Props) {
  const { canUpdate, openFileSelect, handleFilesAdded } = props

  const { isSelectionEnable } = useSelectedAttachmentStore()

  const attachments = useSelector(selectAllAttachments)

  return (
    <Box>
      {attachments?.length == 0 ? (
        <Box mt={1.2} px={2}>
          <Typography variant="body1">No attachments added</Typography>
          <Box mt={1}>
            <FileSelect
              fileMimeTypes={fileMimeTypes}
              onFilesSelected={handleFilesAdded}
              disabled={!canUpdate}
            />
          </Box>
        </Box>
      ) : (
        <Box mt={1.2}>
          <Box
            sx={{
              mb: isSelectionEnable ? 1.6 : 0.8,
              mx: 2,
            }}
          >
            {isSelectionEnable ? (
              <Typography sx={{ mb: 1.2 }} component={'div'} variant="body1">
                Select files to attach to the agreement from the list below.
              </Typography>
            ) : null}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <ButtonWithTooltip
                color="primary"
                variant="text"
                onClick={openFileSelect}
                disabled={!canUpdate}
                showTooltip={!canUpdate}
                tooltipTitle={permissionDenied}
                dataTestId="sale-center-attachments-upload-button"
              >
                Upload New Attachment
              </ButtonWithTooltip>
            </Box>
          </Box>
          <SaleCenterAttachmentsList canUpdate={canUpdate} />
        </Box>
      )}
    </Box>
  )
}
